const finite = (value, fallback) => (Number.isFinite(Number(value)) && value !== null
  ? Number(value) : fallback);

/** Position inside the preview's browser frame, never the surrounding Admin viewport. */
export function resolveDropdownPreviewBounds(viewport, anchor, configured) {
  const positioning = configured || {
    mode: 'constrained',
    align: 'right',
    minDropdownWidth: 0,
    preferredDropdownWidth: anchor.width * 1.4,
    maxDropdownWidth: 600,
    viewportMargin: 8,
    offsetY: 8,
  };
  const width = Math.max(0, viewport.width);
  const height = Math.max(0, viewport.height);
  const margin = Math.max(0, Math.min(finite(positioning.viewportMargin, 16), width / 2, height / 2));
  const top = Math.min(height - margin, Math.max(margin, anchor.bottom + finite(positioning.offsetY, 0)));
  const maxHeight = Math.max(0, Math.min(finite(positioning.maxHeight, 720), height - top - margin));
  if (!positioning.mode || positioning.mode === 'fullWidth') {
    return { left: 0, top, width, maxHeight };
  }

  const minWidth = Math.max(0, finite(positioning.minDropdownWidth, 600));
  const preferredWidth = finite(positioning.preferredDropdownWidth, Math.max(anchor.width, minWidth));
  const panelWidth = Math.max(0, Math.min(
    width - margin * 2,
    finite(positioning.maxDropdownWidth, 1440),
    Math.max(anchor.width, minWidth, preferredWidth),
  ));
  const viewportAligned = positioning.alignTo === 'viewport';
  const referenceLeft = viewportAligned ? margin : anchor.left;
  const referenceRight = viewportAligned ? width - margin : anchor.right;
  const referenceCenter = viewportAligned ? width / 2 : anchor.left + anchor.width / 2;
  const requestedLeft = positioning.align === 'right'
    ? referenceRight - panelWidth
    : positioning.align === 'center' ? referenceCenter - panelWidth / 2 : referenceLeft;
  const left = Math.max(margin, Math.min(requestedLeft, width - margin - panelWidth));
  return { left, top, width: panelWidth, maxHeight };
}

/** The same configured inline/drawer boundary used by the storefront surface. */
export function resolvePreviewFacetPresentation(surface, inlineSize, isMobile) {
  const configured = surface?.facets?.presentation;
  const options = configured && typeof configured === 'object' ? configured : {};
  const type = typeof configured === 'string' ? configured : options.type || options.mode;
  if (!type || type === 'legacy') return undefined;
  if (type !== 'auto') return type;
  if (!Number.isFinite(inlineSize) || inlineSize <= 0) return isMobile ? 'drawer' : undefined;
  const minWidth = finite(options.inlineMinWidth ?? surface.facets.inlineMinWidth, 1200);
  return inlineSize >= minWidth ? 'inline' : options.narrow || options.fallback || surface.facets.narrow || 'drawer';
}
